import React from 'react';
import StreamerInfo from './StreamerInfo.jsx';

class StreamerList extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			streamersInfo: false,
			intervalIndex: 0,
		};
	}

	// Si le composant a été utilisé
	componentDidMount() {
		// On retient les informations dont on a besoin pour l'interval
		const updateSteamerInfoFromAPI = this.updateSteamerInfoFromAPI;
		const updateStreamersInfoState = this.updateStreamersInfoState;
		const elem = this;

		// On appelle la fonction pour update la liste
		updateSteamerInfoFromAPI(updateStreamersInfoState, elem)

		// On créé l'interval
		this.interval = setInterval(function() {
			// On appelle la fonction pour update la liste
			updateSteamerInfoFromAPI(updateStreamersInfoState, elem)
		}, 30000);
	}

	// Si le composant va être retiré
	componentWillUnmount() {
		clearInterval(this.interval);
	}

	// Aperçu des props avant que le Component s'update
	getSnapshotBeforeUpdate(prevProps, prevState) {
		// Si on a changé d'année
		if (this.props.match.params.year !== prevProps.match.params.year) {
			// On supprime les infos des streamers pour afficher les placeholders
			this.updateStreamersInfoState(false, this);
			
			// On appelle la fonction pour update la liste
			this.updateSteamerInfoFromAPI(this.updateStreamersInfoState, this);
		}

		return null;
	}

	// Permet de mettre à jour le State streamersInfo
	updateStreamersInfoState(data, elem) {
		elem.setState({
			streamersInfo: data,
			intervalIndex: elem.state.intervalIndex + 1,
		});
	}

	// Fonction permettant de mettre à jour les infos de streamer
	updateSteamerInfoFromAPI(callback, elem) {
		// On initialise la liste des streamers par année
		const listByYear = {
			'2018': 'ZeratoR,Aayley,Alderiate,esl_alphacast,aypierre,Bestmarmotte,DrFeelGood,Diabalzane,Doigby,Domingo,Gius,gotaga,Hexakii,Jeeltv,jirayalecochon,kamet0,Kennystream,Laink,w_lapin,mynameisLege,esl_locklear,Leroibisou,Luttilutti,maghla,mickalow,MisterMV,Momanus,narkuss_lol,Nono_lol,nyoarchives,Sardochelol,terracid,mythixtrinity,Tweekz,wakzlol,Xari,Zanki0h',
			'2017': 'ZeratoR,Aayley,Alderiate,esl_alphacast,Benzaie,Bestmarmotte,Dachtv,Diabalzane,Doigby,Domingo,DrFeelGood,Gius,Gobgg,Hexakii,ifresh_hd,Jeeltv,Kennystream,Laink,w_lapin,mynameisLege,Leroibisou,Luttilutti,Mamytwink,MisterMV,Momanus,Nono_lol,Sardochelol,Tweekz,Velahan,Xari,Zanki0h',
		};

		// On récupère la liste des streamers de l'année courante
		const listCurrentYear = listByYear[elem.props.match.params.year];

		// On lance la requête pour récupérer les infos des streamers depuis leur pseudo
		fetch(
			'https://api.twitch.tv/helix/users?login=' + listCurrentYear.replace(/,/g, '&login='),
			{
				methode: 'GET',
				headers: {
					'Accept': 'application/vnd.twitchtv.v5+json',
					'Client-ID': 'ix3xd6gp16jj5whol1f106f4bmcjs4',
				}
			}
		)
		.then(results => {
			return results.json();
		})
		.then(data => {
			// On récupère le tableau de streamer
			const arrayStreamersAPI = data.data;

			// On instancie un objet contenant toutes les informations nécessaires
			let objInfosAll = {};

			// On instancie un objet permettant de convertir l'id en pseudo
			let objIdToUsername = {};

			// On instancie un tableau qui récupérera les id twitch des streamers
			let arrayStreamersIdsAPI = [];

			// On parcourt le tableau de streamer de l'API
			arrayStreamersIdsAPI = arrayStreamersAPI.map((streamer) => {
				// On récupère le nom du streamer
				const rawStreamerName = streamer.display_name;

				// On capitalize le nom du streamer
				const streamerName = rawStreamerName.charAt(0).toUpperCase() + rawStreamerName.slice(1);

				// On ajoute notre streamer à notre tableau général
				objInfosAll[streamerName] = {};

				// On ajoute les infos du streamer à notre tableau général
				objInfosAll[streamerName].streamerInfo = streamer;
				objInfosAll[streamerName].streamInfo = false;

				// On ajoute le lien entre l'id et le username dans notre tableau de conversion
				objIdToUsername[streamer.id] = streamerName;

				// On retourne l'id du streamer
				return streamer.id;
			});

			// On concatène tous les ids de streamer
			const stringStreamersIdsAPI = arrayStreamersIdsAPI.join('&user_id=');

			// On lance le deuxième appel API pour récupérer les infos de la chaine
			fetch(
				'https://api.twitch.tv/helix/streams?user_id=' + stringStreamersIdsAPI,
				{
					method: 'GET',
					headers: {
						'Accept': 'application/vnd.twitchtv.v5+json',
						'Client-ID': 'ix3xd6gp16jj5whol1f106f4bmcjs4',
					}
				}
			)
			.then(results => {
				return results.json();
			})
			.then (data => {
				// On récupère le tableau de stream
				const arrayStreamsAPI = data.data;

				// On instancie un tableau qui récupérera les id des jeux joués
				let arrayGamesPlayedIdsAPI = [];

				// On parcourt les streams API
				arrayGamesPlayedIdsAPI = arrayStreamsAPI.map(stream => {
					// On récupère l'id du streamer
					const streamerID = stream.user_id;

					// On récupère le nom du streamer
					const streamerName = objIdToUsername[streamerID];

					// On met ajoute l'index d'interval à la fin de la preview medium
					stream.thumbnail_url += '?v=' + elem.state.intervalIndex;

					// On ajoute l'info du stream à notre tableau général
					objInfosAll[streamerName].streamInfo = stream;

					// On ajoute l'id du jeu à notre tableau
					return stream.game_id;
				});

				// On concatène tous les ids de streamer
				const stringGamesPlayedIdsAPI = arrayGamesPlayedIdsAPI.join('&id=');

				// On lance le deuxième appel API pour récupérer les infos de la chaine
				fetch(
					'https://api.twitch.tv/helix/games?id=' + stringGamesPlayedIdsAPI,
					{
						method: 'GET',
						headers: {
							'Accept': 'application/vnd.twitchtv.v5+json',
							'Client-ID': 'ix3xd6gp16jj5whol1f106f4bmcjs4',
						}
					}
				)
				.then(results => {
					return results.json();
				})
				.then (data => {
					// On récupère le tableau de jeux
					const arrayGamesAPI = data.data;

					// On instancie un obj qui fait le lien entre idGame et infoGame
					let objIdGameToInfoGame = {};

					// On parcourt notre tableau général
					arrayGamesAPI.map(game => {
						// On met à jour notre objet
						objIdGameToInfoGame[game.id] = game;
					});

					// On instancie deux tableaux contenant les pseudo des streamers en ligne et hors ligne
					let onlineStreamers = [];
					let offlineStreamers = [];

					// On parcourt notre tableau général
					for(const streamerName in objInfosAll) {
						// Si nous n'avons pas d'info sur le stream
						if (objInfosAll[streamerName].streamInfo === false) {
							// On l'ajoute aux streamers offline
							offlineStreamers.push(streamerName);
						} else {
							// On récupère l'id du jeu joué
							const idGamePlayed = objInfosAll[streamerName].streamInfo.game_id;

							// On lui ajoute les infos du jeu
							objInfosAll[streamerName].streamInfo.game = objIdGameToInfoGame[idGamePlayed];

							// On l'ajoute aux streamers online
							onlineStreamers.push(streamerName);
						}
					}

					// On trie par ordre alphabetique les streamers en ligne
					onlineStreamers.sort((a, b) => {
						if (a < b) {
							return -1;
						} else if (a === b) {
							return 0;
						} else {
							return 1;
						}
					});

					// On trie par ordre alphabetique les streamers hors ligne
					offlineStreamers.sort((a, b) => {
						if (a < b) {
							return -1;
						} else if (a === b) {
							return 0;
						} else {
							return 1;
						}
					});

					// On instancie un objet pour les infos triées
					let objInfosAllSorted = {};

					// On parcourt les streamers en ligne
					onlineStreamers.map(streamerName => {
						// On ajoute l'info à notre tableau trié
						objInfosAllSorted[streamerName] = objInfosAll[streamerName];
					});

					// On parcourt les streamers hors ligne
					offlineStreamers.map(streamerName => {
						// On ajoute l'info à notre tableau trié
						objInfosAllSorted[streamerName] = objInfosAll[streamerName];
					});
					
					console.log(objInfosAllSorted);
					// On appelle le callback passé en paramètre
					callback(objInfosAllSorted, elem);
				});
			});
		});
	}

	render () {
		if (! this.state.streamersInfo) {
			// On instancie notre tableau contenant nos JSX
			let streamListJSX = [];

			// On parcourt 31 fois pour créer les emplacements des 31 streamers
			for (let i = 0; i < 31; i++) {
				// On ajoute le jsx
				streamListJSX.push(
					<div key={"strealItemPlaceholder_" + i}>
						<StreamerInfo isLoading={true} />
						<hr />
					</div>
				);
			}

			return (
				<div>
					{streamListJSX}
				</div>
			);
		}

		// On instancie un tableau contenant le jsx des streamers
		let streamersInfoJSX = []; 

		// On parcourt les infos des streamers
		for(const streamerName in this.state.streamersInfo) {
			streamersInfoJSX.push((
				<div key={streamerName}>
					<StreamerInfo streamerInfo={this.state.streamersInfo[streamerName].streamerInfo}
						streamInfo={this.state.streamersInfo[streamerName].streamInfo}
						streamerNameCapitalized={streamerName} />
					<hr />
				</div>
			));
		}

		return (
			<div>
				{streamersInfoJSX}
			</div>
		);
	}
}

export default StreamerList;